import script from "./ContentHighlightsListItemEdit.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentHighlightsListItemEdit.vue?vue&type=script&lang=ts&setup=true"

import "./ContentHighlightsListItemEdit.vue?vue&type=style&index=0&id=30ecc6e9&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30ecc6e9"]])

export default __exports__